/**
 * @generated SignedSource<<27c41dff7e6fc701c4c088c403e2c775>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserProfileUpdateInput = {
  externalRef?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  countryId?: string | null;
  timeZone?: string | null;
  languages?: any | null;
  gender?: string | null;
  phone?: string | null;
  ageGroup?: string | null;
  dob?: string | null;
  photoUrls?: any | null;
  iP?: string | null;
  setupComplete?: boolean | null;
  email?: string | null;
  hubspotId?: string | null;
  city?: string | null;
  state?: string | null;
  isAuOrigin?: boolean | null;
  workosDirUserRef?: string | null;
  timeZoneOffset?: number | null;
  googleCredentials?: any | null;
  defaultLanguage?: string | null;
  ethnicity?: any | null;
  accountId?: string | null;
};
export type userUpdateUserProfileMutation$variables = {
  id: string;
  input: UserProfileUpdateInput;
};
export type userUpdateUserProfileMutation$data = {
  readonly updateUserProfile: {
    readonly userProfile: {
      readonly " $fragmentSpreads": FragmentRefs<"userProfileNameFragment" | "userProfileBaseFragment" | "userLocationFragment">;
    };
  };
};
export type userUpdateUserProfileMutation = {
  variables: userUpdateUserProfileMutation$variables;
  response: userUpdateUserProfileMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "userUpdateUserProfileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserProfilePayload",
        "kind": "LinkedField",
        "name": "updateUserProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "userProfile",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "userProfileNameFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "userProfileBaseFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "userLocationFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "userUpdateUserProfileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserProfilePayload",
        "kind": "LinkedField",
        "name": "updateUserProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "userProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalRef",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeZone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "photoUrls",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "languages",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "setupComplete",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "googleCredentials",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gender",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ethnicity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "51ce07c985c4632189208060e2b94188",
    "id": null,
    "metadata": {},
    "name": "userUpdateUserProfileMutation",
    "operationKind": "mutation",
    "text": "mutation userUpdateUserProfileMutation(\n  $id: ID!\n  $input: UserProfileUpdateInput!\n) {\n  updateUserProfile(id: $id, input: $input) {\n    userProfile {\n      ...userProfileNameFragment\n      ...userProfileBaseFragment\n      ...userLocationFragment\n      id\n    }\n  }\n}\n\nfragment userLocationFragment on UserProfile {\n  city\n  state\n  countryId\n}\n\nfragment userProfileBaseFragment on UserProfile {\n  id\n  email\n  externalRef\n  countryId\n  timeZone\n  photoUrls\n  phone\n  languages\n  setupComplete\n  googleCredentials\n  gender\n  ethnicity\n}\n\nfragment userProfileNameFragment on UserProfile {\n  firstName\n  lastName\n}\n"
  }
};
})();

(node as any).hash = "71efed4fd4f35fa6243b809cb775fe92";

export default node;
